import { FormModal }          from '@widesk-ui/components/modal/FormModal';
import preventConcurrentCalls from '@/tools/preventConcurrentCalls';
import MapImagePicker         from '@/TokamapEditor/ux/MapImagePicker';

/**
 * Importe une image de la carte, dans la limite de l'abonnement, ou en reprend une déjà envoyée sur
 * le projet, et donne son adresse à `onPicked`.
 */
async function openMapImagePicker(title: string, onPicked: (src: string) => unknown) {
	return FormModal.open({
		children: <MapImagePicker onPicked={image => onPicked(image.src)} />,
		title,
	});
}

const pickMapImage = preventConcurrentCalls(openMapImagePicker);

export default pickMapImage;
